export const SET_INVOICE_PAGE = 'scrollposition:set-invoice-page';
export const SET_PREREGISTERED_INVOICE_PAGE = 'scrollposition:set-preregistered-invoice-page';
export const SET_SCROLL_POSITION = 'scrollposition:set';
export const CLEAR_SCROLL_POSITION = 'scrollposition:clear';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/scroll-positions/action-types.js
 **/